import React, { useMemo, useContext, useState, useRef, useEffect } from 'react';
import Brand from './Brand';
import Menu from './Menu';
import { AuthContext } from '../../../../contexts/AuthContext';
import { Menus } from '../../../../utils/appConstant';
import { hasResourseAccess } from '../../../../utils/methods';

interface SidebarProps {
  collapsed: boolean;
  onCollapse: (_: boolean) => void;
}

const Sidebar: React.FC<SidebarProps> = ({ collapsed, onCollapse }) => {
  const { permissions, isSystemAdmin } = useContext(AuthContext);
  const [hovered, setHovered] = useState<boolean>(false);
  const asideRef = useRef<HTMLLIElement>(null);

  useEffect(() => {
    const root = document.documentElement;

    if (root.clientWidth < 1200) {
      const handleClickOutside = (event: MouseEvent) => {
        if (asideRef.current && !asideRef.current.contains(event.target as Node)) {
          onCollapse(true);
        }
      };

      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }
  }, [onCollapse]);

  useEffect(() => {
    const root = document.documentElement;

    if (hovered) {
      root.classList.add('layout-menu-hover');
    } else {
      root.classList.remove('layout-menu-hover');
    }
  }, [hovered]);

  const sideMenus = useMemo(() => {
    return Menus.filter((menu) => {
      return hasResourseAccess(
        isSystemAdmin,
        permissions,
        menu.accessibleTo || menu.childrens ? menu : null
      );
    });
  }, [permissions, isSystemAdmin]);

  const handleOnMouseEnter = () => {
    const root = document.documentElement;

    if (root.clientWidth >= 1200) {
      setHovered(true);
    }
  };

  const handleOnMouseLeave = () => {
    const root = document.documentElement;

    if (root.clientWidth >= 1200) {
      setHovered(false);
    }
  };

  return (
    <aside
      ref={asideRef}
      id="layout-menu"
      className="layout-menu menu-vertical menu bg-menu-theme"
      onMouseEnter={handleOnMouseEnter}
      onMouseLeave={handleOnMouseLeave}
    >
      <Brand sidebarExpanded={hovered || !collapsed} />
      <hr className="m-0 separator-app-brand"></hr>
      <div className="menu-inner-shadow"></div>

      <ul className="menu-inner py-1 menu-inner-custom">
        {sideMenus.map((sideMenu) => (
          <Menu key={sideMenu.id} {...sideMenu} sidebarExpanded={hovered || !collapsed} />
        ))}
      </ul>
    </aside>
  );
};

export default Sidebar;
